/**
 * EB 按钮权限（菜单 auth + 用户 access）
 * access 来自 GET mer/info，与 PHP MerchantAuthMiddleware 中权限 route 一致
 */
import useCrmebMenuStore from '@/store/modules/menu';
import useUserStore from '@/store/modules/user';
import { includeArray } from '@/utils/crmebMenu';

/** level=0 主管理员；access 为空表示不限制（与 PHP 子账号 access 列表区分） */
function isCrmebSuperAdmin(): boolean {
  const level = useUserStore().crmebAdminLevel;
  return level === 0 || level === undefined || level === null;
}

function hasAuth(value: string | string[]): boolean {
  const access = useCrmebMenuStore().access;
  const list = Array.isArray(value) ? value : [value];
  if (!access?.length) {
    return isCrmebSuperAdmin();
  }
  return includeArray(list, access);
}

/** 模板 v-if 用（勿在 el-dropdown-item / router-link 等非单根组件上用 v-eb-auth） */
function authVisible(value?: string | string[]): boolean {
  if (value === undefined || value === null || value === '') return true;
  if (Array.isArray(value)) {
    return value.some((v) => hasAuth(v));
  }
  return hasAuth(value);
}

export default {
  hasAuth,
  hasAuthOr(values: string[]) {
    return values.some((v) => hasAuth(v));
  },
  hasAuthAnd(values: string[]) {
    return values.every((v) => hasAuth(v));
  },
  authVisible,
};
